import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import LearningDeatil from './learning-detail';

const DetailSubMateri = () => {
  return (
    <Fragment>
      <Container fluid={true}>
        <Row className='learning-block'>
          <LearningDeatil />
        </Row>
      </Container>
    </Fragment>
  );
};

export default DetailSubMateri;